import { LocalizedPlayer } from "../../../../types/player"
import * as ImageConstants from "../../../../constants/images"
import { playerRoleToTranslation } from "../../../../utils/player"
import { CountryImageName } from "@components/Country/CountryImageName"
import Image from "next/image"
import style from "./style.module.scss"
import { Row, Col } from "react-bootstrap"
import { PlayerCareer } from "../PlayerCareer/PlayerCareer"
import { LocalizedSeasonTeamPlayer } from "types/seasonTeamPlayer"

export function PlayerProfile({ player, teams }: { player: LocalizedPlayer; teams: LocalizedSeasonTeamPlayer[] }) {
  return (
    <div className={style.playerProfileContainer}>
      <Row className={style.card}>
        <Col className={style.left} lg={7}>
          <div className={style.imgContainer}>
            <Image
              src={player.image?.path || ImageConstants.PLAYER_MISSING_IMAGE_PATH}
              alt={player.name}
              title={player.name}
              className={"person-image-player"}
              layout={"intrinsic"}
              width={180}
              height={180}
            />
          </div>
          <div className={style.playerInfo}>
            <h1>{player.name}</h1>
            <div className={style.actualTeamContainer}>
              <Image
                className={"info-team-image"}
                src={player.currentTeam?.image?.path || ImageConstants.TEAM_MISSING_IMAGE_PATH}
                alt={player?.currentTeam?.name}
                title={player?.currentTeam?.name}
                layout={"intrinsic"}
                width={50}
                height={50}
              />
              <span>{player.currentTeam?.name}</span>
            </div>
          </div>
        </Col>
        <Col className={style.right} lg={5}>
          <div className={style.imgContainer}>
            <div className={style.imgWrapper}>
              <Image
                src={player.image?.path || ImageConstants.PLAYER_MISSING_IMAGE_PATH}
                alt={player.name}
                title={player.name}
                className={"person-image-player"}
                layout={"intrinsic"}
                width={180}
                height={180}
              />
            </div>
          </div>
          <div className={style.infoContainer}>
            <Row className={style.labelRow}>
              <Col xs={4} sm={4} md={4} lg={4} xl={4} className={style.label}>
                <span>Nome</span>
              </Col>
              <Col xs={8} sm={8} md={8} lg={8} xl={8} className={style.labelValue}>
                <span>
                  {player.firstName} {player.lastName}
                </span>
              </Col>
            </Row>
            {player.country && (
              <Row className={style.labelRow}>
                <Col xs={4} sm={4} md={4} lg={4} xl={4} className={style.label}>
                  <span>Paese</span>
                </Col>
                {player.country && player.country2 ? (
                  <Col xs={8} sm={8} md={8} lg={8} xl={8} className={style.labelValue}>
                    <CountryImageName country={player.country} />
                    <CountryImageName country={player.country2} />
                  </Col>
                ) : (
                  <Col xs={8} sm={8} md={8} lg={8} xl={8} className={style.labelValue}>
                    <CountryImageName country={player.country} />
                  </Col>
                )}
              </Row>
            )}
            <Row className={style.labelRow}>
              <Col xs={4} sm={4} md={4} lg={4} xl={4} className={style.label}>
                <span>Nato il</span>
              </Col>
              <Col xs={8} sm={8} md={8} lg={8} xl={8} className={style.labelValue}>
                <span>{player.birthday}</span>
              </Col>
            </Row>
            <Row className={style.labelRow}>
              <Col xs={4} sm={4} md={4} lg={4} xl={4} className={style.label}>
                <span>Altezza</span>
              </Col>
              <Col xs={8} sm={8} md={8} lg={8} xl={8} className={style.labelValue}>
                <span>{player.height} cm</span>
              </Col>
            </Row>
            <Row className={style.labelRow}>
              <Col xs={4} sm={4} md={4} lg={4} xl={4} className={style.label}>
                <span>Peso</span>
              </Col>
              <Col xs={8} sm={8} md={8} lg={8} xl={8} className={style.labelValue}>
                <span>{player.weight} Kg</span>
              </Col>
            </Row>
            {player.role && (
              <Row className={style.labelRow}>
                <Col xs={4} sm={4} md={4} lg={4} xl={4} className={style.label}>
                  <span>Ruolo</span>
                </Col>
                <Col xs={8} sm={8} md={8} lg={8} xl={8} className={style.labelValue}>
                  <span>{playerRoleToTranslation(player.role)}</span>
                </Col>
              </Row>
            )}
          </div>
        </Col>
      </Row>

      <PlayerCareer teams={teams} />
    </div>
  )
}
